<template>
    <div v-show="isOn" class="loader-overlay">
        <div class="loader"></div>
    </div>
</template>

<script>
    export default {
        name: 'busy-spinner',
        props: {
            isOn: Boolean,
        },
        data() {
            return {

            };
        },
        methods: {
        },
    }
</script>

<style scoped>
    .loader-overlay{
        background-color: rgba(0, 0, 0, 0.3);
        width:      100%;
        height:     100%;
        top:        0;
        left:       0;
        position:   fixed;
        z-index: 99999999;
    }

    @keyframes spin {
        from {transform:rotate(0deg);}
        to {transform:rotate(360deg);}
    }
    .loader {
        border: 8px solid #f3f3f3;
        border-top: 8px solid #3498db;
        border-radius: 50%;
        width: 60px;
        height: 60px;
        animation: spin 2s linear infinite;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: -2.2em;
        margin-left: -2.2em;
    }
</style>
